import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { observable } from 'mobx';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { FormQuestionType } from '@atlassian/proforma-common-core/form-system-models';
import { FormStore } from '@atlassian/proforma-common-core/form-system-stores';
import { AFFECTED_SERVICES_SCHEMA_CUSTOM, CMDB_SCHEMA_CUSTOM, convertAnswers, convertTemplateFormToUnsavedForm, getCmdbFieldValueMap, LABELS_SCHEMA_CUSTOM, LABELS_SCHEMA_SYSTEM } from '@atlassian/proforma-common-core/form-system-utils';
import { loadChoicesAsyncFn, loadChoicesFn, loadFieldDataFn } from '@atlassian/proforma-common-core/jira-common-stores';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { messages } from './messages';
export var PortalCreateStore = (_class = /*#__PURE__*/_createClass(function PortalCreateStore(intl, moduleContext, registerPortalFormCallback, createAnalyticsEvent, onFieldChange, onFieldDirty, portalId, showFlag, proformaTemplateForm) {
  var _this = this;
  _classCallCheck(this, PortalCreateStore);
  _initializerDefineProperty(this, "loadingForm", _descriptor, this);
  _initializerDefineProperty(this, "formStore", _descriptor2, this);
  _initializerDefineProperty(this, "creatingIssue", _descriptor3, this);
  this.reporterAccountId = void 0;
  this.createAnalyticsEvent = void 0;
  this.attemptValidatingForm = function (callback) {
    if (!_this.loadingForm) {
      if (_this.formStore) {
        if (_this.formStore.validateOnCreate) {
          _this.formStore.validate();
        }
        callback(!_this.formStore.invalid);
        return;
      }

      // There is no form so pass the validation
      callback(true);
      return;
    }
    // User clicked the "Create" button before the form finished loading so auto-fail validation
    callback(false);
  };
  this.attemptSerializeFormAnswers = function (callback) {
    var _this$formStore, _this$formStore2;
    var serializedFormAnswers = _this.formStore ? {
      templateFormId: _this.formStore.templateFormId,
      answers: convertAnswers(_this.formStore.questions)
    } : undefined;
    callback(serializedFormAnswers);
    fireTrackAnalytics(_this.createAnalyticsEvent({}), "".concat(ActionSubject.FORM, " ").concat(Action.CREATED), {
      templateFormId: (_this$formStore = _this.formStore) === null || _this$formStore === void 0 ? void 0 : _this$formStore.templateFormId,
      formId: 1,
      // Form created from portal create is always guaranteed formId of 1
      hasCascadingFields: (_this$formStore2 = _this.formStore) === null || _this$formStore2 === void 0 ? void 0 : _this$formStore2.questions.some(function (question) {
        return question.formQuestion.type === FormQuestionType.ChoiceCascading;
      })
    });
  };
  this.createAnalyticsEvent = createAnalyticsEvent;
  Promise.resolve(convertTemplateFormToUnsavedForm(proformaTemplateForm)).then(function (form) {
    if (form) {
      _this.formStore = new FormStore(intl, createAnalyticsEvent, loadFieldDataFn(function (request) {
        return moduleContext.apis.portalCreateFormApi.postFieldData(form.design.settings.templateId, request);
      }, moduleContext.utils.errorUtils, false), loadChoicesFn(moduleContext.apis.portalCreateFormApi.getFormChoices.bind(moduleContext.apis.portalCreateFormApi), moduleContext.utils.errorUtils, true, createAnalyticsEvent), loadChoicesAsyncFn({
        custom: _defineProperty(_defineProperty(_defineProperty({}, AFFECTED_SERVICES_SCHEMA_CUSTOM, {
          searchOptionsFn: function searchOptionsFn(_, query) {
            return moduleContext.apis.portalCreateFormApi.searchAffectedServices(query);
          }
        }), CMDB_SCHEMA_CUSTOM, {
          searchOptionsFn: function searchOptionsFn(jiraField, query, _, form) {
            return form && moduleContext.apis.portalCreateFormApi.searchCmdb(jiraField, query, _objectSpread(_objectSpread({}, _this.reporterAccountId ? {
              reporter: _this.reporterAccountId
            } : {}), getCmdbFieldValueMap(form))) || Promise.resolve([]);
          },
          onSearchError: function onSearchError(_ref) {
            var status = _ref.status;
            if (status === 400) {
              return {
                title: intl.formatMessage(messages.objectSearchErrorTitle),
                description: intl.formatMessage(messages.objectSearchErrorDescription)
              };
            }
          }
        }), LABELS_SCHEMA_CUSTOM, {
          searchOptionsFn: function searchOptionsFn(jiraField, query) {
            return !query.includes(' ') && moduleContext.apis.portalCreateFormApi.searchLabels(portalId, jiraField, query) || Promise.resolve([]);
          }
        }),
        system: _defineProperty({}, LABELS_SCHEMA_SYSTEM, {
          searchOptionsFn: function searchOptionsFn(jiraField, query) {
            return !query.includes(' ') && moduleContext.apis.portalCreateFormApi.searchLabels(portalId, jiraField, query) || Promise.resolve([]);
          }
        })
      }, moduleContext.utils.errorUtils, createAnalyticsEvent, showFlag), function (jiraField, query) {
        return moduleContext.apis.portalCreateFormApi.searchUsers(jiraField, query);
      }, function (jiraField, fieldConfigId, query) {
        return moduleContext.apis.portalCreateFormApi.searchUsersWithFieldConfig(portalId, jiraField, fieldConfigId, query);
      }, form, true, undefined, undefined, onFieldChange, onFieldDirty);
      registerPortalFormCallback(_this.attemptValidatingForm.bind(_this), _this.attemptSerializeFormAnswers.bind(_this));
    }
  }).finally(function () {
    _this.loadingForm = false;
  });
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "loadingForm", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formStore", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "creatingIssue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);